import axios from 'axios'
import { TextControl } from '@wordpress/components'
import { useDispatch, useSelect } from '@wordpress/data'

const classmateNameFields = [
  'usna1978_first_name',
  'usna1978_middle_name',
  'usna1978_last_name',
  'usna1978_suffix'
]
const classmateAddressFields = [
  'usna1978_address_city',
  'usna1978_address_state',
  'usna1978_address_zip'
]

/* eslint no-extend-native: ["error", { "exceptions": ["String"] }] */
String.prototype.toUpperCaseWords = function () {
  return this.replace(/\w+/g, (a) => {
    return a.charAt(0).toUpperCase() + a.slice(1).toLowerCase()
  })
}

const updateTitleWithName = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const meta = useSelect(
    select => select('core/editor').getEditedPostAttribute('meta'),
    []
  )

  let names = [meta['usna1978_first_name'].toUpperCaseWords()]
  if (meta['usna1978_middle_name']) {
    names = [...names, ...[meta['usna1978_middle_name'].charAt(0).toUpperCase()]]
  }
  names = [...names, ...[meta['usna1978_last_name'].toUpperCaseWords()]]
  if (meta['usna1978_suffix']) {
    names = [...names, ...[meta['usna1978_suffix']]]
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useDispatch('core/editor').editPost({ title: names.join(' ') })
}

const updateLocation = () => {
  console.log('Calling the update location')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const meta = useSelect(
    select => select('core/editor').getEditedPostAttribute('meta'),
    []
  )

  axios.get(
    'https://maps.googleapis.com/maps/api/geocode/json?address=' +
    encodeURIComponent(
      meta['usna1978_address_city'] + ', ' +
      meta['usna1978_address_state'] + ' ' +
      meta['usna1978_address_zip']
    ) + '&sensor=false&key=AIzaSyBqojPzm9rPgluoRT4kLl5oGHH0lwkUrK0'
  ).then((response) => {
    console.log(response)
    if (response.data.results[0].geometry) {
      useDispatch('core/editor').editPost({
        meta: {
          usna1978_address_lat: response.data.results[0].geometry.location.lat + '',
          usna1978_address_long: response.data.results[0].geometry.location.lng + ''
        }
      })
    }
  }).catch((error) => console.log(error))
}

/**
 * Alter post meta with a text field.
 *
 * @param fieldname
 * @param disabled
 * @returns {JSX.Element}
 * @constructor
 *
 * @link https://developer.wordpress.org/block-editor/how-to-guides/metabox/
 */
const MetaTextField = ({ fieldName, disabled }) => {
  const metaFieldValue = useSelect(
    select => select('core/editor').getEditedPostAttribute('meta')[fieldName],
    []
  )

  const setMetaFieldValue = useDispatch('core/editor').editPost

  return (
    <TextControl
      value={metaFieldValue}
      onChange={content => {
        setMetaFieldValue({ meta: { [fieldName]: content } })
        if (classmateNameFields.includes(fieldName)) {
          console.log('ran update')
          updateTitleWithName()
        }
      }}
      onBlur={() => {
        if (classmateAddressFields.includes(fieldName)) {
          console.log('Updated lat long details')
          updateLocation()
        }
      }}
      disabled={!!disabled}
    />
  )
}

export default MetaTextField
